// extracted by mini-css-extract-plugin
module.exports = {"light_ui-checkbox-color":"#070d17","dark_ui-checkbox-color":"#fff"};